var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 14.0256V2.87182C1.66602 2.53507 1.78268 2.25002 2.01602 2.01669C2.24935 1.78335 2.53439 1.66669 2.87115 1.66669H13.1275C13.4643 1.66669 13.7493 1.78335 13.9826 2.01669C14.216 2.25002 14.3327 2.53507 14.3327 2.87182V10.4615C14.3327 10.7983 14.216 11.0833 13.9826 11.3167C13.7493 11.55 13.4643 11.6667 13.1275 11.6667H4.02498L1.66602 14.0256ZM3.59935 10.6667H13.1275C13.1788 10.6667 13.2258 10.6453 13.2686 10.6026C13.3113 10.5598 13.3327 10.5128 13.3327 10.4615V2.87182C13.3327 2.82053 13.3113 2.77352 13.2686 2.73077C13.2258 2.68804 13.1788 2.66667 13.1275 2.66667H2.87115C2.81986 2.66667 2.77284 2.68804 2.7301 2.73077C2.68737 2.77352 2.666 2.82053 2.666 2.87182V11.5898L3.59935 10.6667Z",
    fill: "black",
    fillOpacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.37b95605f2f5127f3c626f1e9721f8c8.svg";
export { ForwardRef as ReactComponent };